import { PageHeader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import Shimmer from '~/components/Shimmer';
import { ClientSideMenu } from '~/features/ClientSideMenu';
import { ContractInfoPaymentMethod } from '~/features/ContractInfoPaymentMethod';
import styles from './styles.module.scss';

/**
 * ご契約情報 Screen
 *
 * T01 では画面骨格のみを配置する。会社情報・プラン情報・ご担当者情報・ご請求先情報の
 * セクションは本スパイク（PEN-753）の対象外。お支払い方法セクションのみ配置する。
 */
export const Screen: React.FC = () => (
  <div className={styles.screen}>
    <ClientSideMenu />
    <div className={styles.content}>
      <PageHeader variant='title' title='ご契約情報' />
      <main className={styles.body}>
        <Suspense fallback={<Shimmer />}>
          <ContractInfoPaymentMethod />
        </Suspense>
      </main>
    </div>
  </div>
);
